import { assert_array_typeof_string } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWordsWithRelatedWordsGet extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORD_WITH_RELATED_WORDS_GET;

  words_english!: string[];

  /*
   * METHODS
   */
  constructor() {
    super();

    this.words_english = [];
  }

  assert_standard_fields(): void {
    assert_array_typeof_string(this.words_english);
  }
}
